import { animate, state, style, transition, trigger } from '@angular/animations';
import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { Toast } from 'ngx-toastr';

/**
 * Toast dos avisos de chamado (ChamadoAvisoService): o mesmo formato do de pendência, em azul.
 * `title` é o complemento ("Chamado #120 · Suporte · TI") e `message`, a frase do acontecimento
 * em destaque ("Fulano mudou o chamado #120 para Em teste"). Texto de usuário: interpolação do
 * Angular, nunca innerHTML.
 */
@Component({
  selector: '[app-chamado-toast]',
  standalone: true,
  imports: [NgIf],
  templateUrl: './chamado-toast.component.html',
  styleUrl: './chamado-toast.component.scss',
  // A mesma animação do Toast padrão: o host liga `@flyInOut` ao estado da base.
  animations: [
    trigger('flyInOut', [
      state('inactive', style({ opacity: 0 })),
      state('active', style({ opacity: 1 })),
      state('removed', style({ opacity: 0 })),
      transition('inactive => active', animate('{{ easeTime }}ms {{ easing }}')),
      transition('active => removed', animate('{{ easeTime }}ms {{ easing }}'))
    ])
  ],
  preserveWhitespaces: false
})
export class ChamadoToastComponent extends Toast {
  /** O X fecha sem abrir o chamado (o clique no corpo abre). */
  fechar(evento: Event): void {
    evento.stopPropagation();
    this.remove();
  }
}
